import React from 'react';
import { Link } from 'react-router-dom';

function ComingSoonPage() {
  return (
    <div>
      <section class="py-24 relative">
        <div class="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
          <div class="w-full md:px-16 px-10 md:pt-16 pt-10 pb-10 bg-gray-900 rounded-2xl flex-col justify-end items-center lg:gap-28 md:gap-16 gap-10 inline-flex">
            <div class="flex-col justify-end items-center lg:gap-16 gap-10 flex">
              <img
                src="/img/logo.png"
                alt="finzaid logo image"
                class="object-cover w-[400px] h-[50px]"
              ></img>
              <div class="flex-col justify-center items-center gap-10 flex">
                <div class="flex-col justify-start items-center gap-2.5 flex">
                  <h2 class="text-center text-white md:text-6xl text-5xl font-bold font-manrope leading-normal">
                    Coming Soon...
                  </h2>
                </div>

                <div class="w-full flex-col justify-center items-center gap-5 flex">
                  <Link to={'/'}>
                    <h6 class="text-center cursor-pointer hover:underline underline-red-300 text-emerald-400 text-base font-semibold leading-relaxed">
                      Go to home page
                    </h6>
                  </Link>
                </div>
              </div>
            </div>
            <p class="text-center text-gray-500 text-sm font-normal leading-snug">
              Get in touch with us:{' '}
              <a
                href=""
                class="hover:text-gray-100 transition-all duration-700 ease-in-out"
              >
                {' '}
                www.finzaid.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ComingSoonPage;
